<template>
  <div
    class="modal fade dq-modal"
    id="employee_bulk_delete_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
    data-bs-keyboard="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-body text-center">
          <div class="delete-badge">
            <i class="ti ti-trash-x"></i>
          </div>
          <h4 class="mb-2">Delete selected employees?</h4>
          <p class="text-muted mb-3">
            <b>{{ count }}</b> employee(s) will disappear from this list.
            Their portal login is turned off, and their email can be used for a new employee.
            Payroll, leave, and attendance history stay on file.
          </p>
          <div class="delete-note">
            <i class="ti ti-info-circle me-1"></i>
            This is not the same as Deactivate. To suspend someone and keep them on the list, use Deactivate.
            Your own record is never deleted.
          </div>
          <div class="d-flex justify-content-center flex-wrap gap-2 mt-4">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="submitting">
              Cancel
            </button>
            <button type="button" class="btn btn-danger" :disabled="submitting" @click="confirm">
              <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
              Yes, delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Modal } from "bootstrap";

const emit = defineEmits(["confirmed"]);

const submitting = ref(false);
const ids = ref([]);
const count = ref(0);
let modalInstance = null;

function getModal() {
  const el = document.getElementById("employee_bulk_delete_modal");
  if (!el) return null;
  modalInstance = Modal.getOrCreateInstance(el, { backdrop: false, keyboard: true });
  return modalInstance;
}

function open(employeeIds) {
  const next = (employeeIds || []).map((id) => Number(id)).filter(Boolean);
  if (!next.length) return;
  ids.value = next;
  count.value = next.length;
  submitting.value = false;
  getModal()?.show();
}

function hide() {
  modalInstance?.hide();
}

function confirm() {
  if (submitting.value || !ids.value.length) return;
  emit("confirmed", { ids: [...ids.value] });
}

function setSubmitting(value) {
  submitting.value = !!value;
}

defineExpose({ open, hide, setSubmitting });
</script>

<style scoped>
.delete-badge {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 26px;
  background: rgba(239, 68, 68, 0.12);
  color: rgb(185, 28, 28);
}
.delete-note {
  background: rgba(245, 158, 11, 0.12);
  color: rgb(120, 53, 15);
  border-radius: 12px;
  padding: 10px 12px;
  text-align: left;
  font-size: 13px;
}
</style>
